export const getViewProps = (defaultProps, givenViewProps) => {
  const { style, ...otherGivenViewProps } = givenViewProps;
  const props = {
    ...defaultProps,
    style: {
      ...defaultProps.style,
      ...style,
      overflowX: 'hidden',
    },
    ...otherGivenViewProps,
  };
  return props;
};

export default {
  getViewProps,
};
